import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import recentSearchesManager from '../utils/recentSearches';
import './SavedSearches.css';

function SavedSearches() {
  const [searches, setSearches] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    loadSearches();
  }, []);

  const loadSearches = () => {
    const allSearches = recentSearchesManager.getRecentSearches();
    setSearches(allSearches);
  };

  const handleRemoveSearch = (searchId) => {
    recentSearchesManager.removeSearch(searchId);
    loadSearches();
  };

  const handleClearAll = () => {
    if (window.confirm('Are you sure you want to clear all saved searches?')) {
      recentSearchesManager.clearAllSearches();
      loadSearches();
    }
  };

  const filteredSearches = filter === 'all'
    ? searches
    : searches.filter(search => search.database === filter);

  const getDatabaseDisplayName = (database) => {
    const names = {
      'drugs': 'FDA Drugs',
      'trials': 'Clinical Trials',
      'chemicals': 'ChEMBL',
      'orangebook': 'Orange Book',
      'pubchem': 'PubChem',
      'rxnorm': 'RxNorm',
      'dailymed': 'DailyMed',
      'general': 'General Search'
    };
    return names[database] || database;
  };

  const getDatabaseRoute = (database) => {
    const routes = {
      'drugs': '/drugs',
      'trials': '/trials',
      'chemicals': '/chemicals',
      'orangebook': '/orangebook',
      'pubchem': '/pubchem',
      'rxnorm': '/rxnorm',
      'dailymed': '/dailymed'
    };
    return routes[database] || '/';
  };

  return (
    <div className="page-container">
      <div className="saved-searches-header">
        <h1 className="page-title">💾 Saved Searches</h1>
        <p className="page-description">
          View and manage your recent searches across all pharmaceutical databases
        </p>
      </div>

      <div className="saved-searches-controls">
        <div className="filter-controls">
          <label htmlFor="database-filter">Filter by Database:</label>
          <select
            id="database-filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Databases</option>
            <option value="drugs">FDA Drugs</option>
            <option value="trials">Clinical Trials</option>
            <option value="chemicals">ChEMBL</option>
            <option value="orangebook">Orange Book</option>
            <option value="pubchem">PubChem</option>
            <option value="rxnorm">RxNorm</option>
            <option value="dailymed">DailyMed</option>
          </select>
        </div>

        {searches.length > 0 && (
          <button
            onClick={handleClearAll}
            className="clear-all-btn"
          >
            🗑️ Clear All Searches
          </button>
        )}
      </div>

      {filteredSearches.length === 0 ? (
        <div className="no-searches">
          <h3>No saved searches found</h3>
          <p>
            {filter === 'all'
              ? "You haven't performed any searches yet. Start exploring our pharmaceutical databases!"
              : `No searches found for ${getDatabaseDisplayName(filter)}.`
            }
          </p>
          <Link to="/" className="search-button">
            Start Searching
          </Link>
        </div>
      ) : (
        <div className="searches-grid">
          {filteredSearches.map((search) => (
            <div key={search.id} className="search-card">
              <div className="search-card-header">
                <div className="search-info">
                  <h3 className="search-query">"{search.query}"</h3>
                  <span className="search-database">
                    {getDatabaseDisplayName(search.database)}
                  </span>
                </div>
                <button
                  onClick={() => handleRemoveSearch(search.id)}
                  className="remove-search-btn"
                  title="Remove this search"
                >
                  ✕
                </button>
              </div>

              <div className="search-details">
                <div className="search-meta">
                  <span className="search-timestamp">
                    {recentSearchesManager.formatTimestamp(search.timestamp)}
                  </span>
                  {search.resultsCount > 0 && (
                    <span className="search-results">
                      {search.resultsCount} result{search.resultsCount !== 1 ? 's' : ''}
                    </span>
                  )}
                </div>
              </div>

              <div className="search-actions">
                <Link
                  to={`${getDatabaseRoute(search.database)}?q=${encodeURIComponent(search.query)}`}
                  className="re-run-search-btn"
                >
                  🔍 Re-run Search
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SavedSearches;